import { Popover, Portal } from "@chakra-ui/react";

import { CheckboxSelectList } from "../checkbox-select-list";
import { CheckboxOptionType } from "../checkbox-select-list/types";

import { MultiSelectToggle } from "./multiselect-toggle";

type MultiSelectDropdownProps<T extends string> = {
  name: string;
  placement?: "top-start" | "top-end" | "bottom-start" | "bottom-end";
  values?: T[];
  options?: CheckboxOptionType<T>[];
  label: string;
  pluralLabel: string;

  onChangeValues?: (values: T[]) => void;
};

export const MultiSelectDropdown = <T extends string>({
  label,
  pluralLabel,
  placement = "bottom-start",
  name,
  values = [],
  options = [],
  onChangeValues,
}: MultiSelectDropdownProps<T>) => {
  const selectedOptions = options.filter(option => values.includes(option.value));

  const handleClear = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onChangeValues?.([]);
  };

  return (
    <Popover.Root
      lazyMount
      unmountOnExit
      positioning={{ placement, offset: { crossAxis: 0, mainAxis: 8 } }}
    >
      <Popover.Trigger asChild>
        <MultiSelectToggle
          label={label}
          pluralLabel={pluralLabel}
          onClear={handleClear}
          selectedOptions={selectedOptions}
        />
      </Popover.Trigger>
      <Portal>
        <Popover.Positioner>
          <Popover.Content>
            <CheckboxSelectList
              name={name}
              values={values}
              options={options}
              onChangeValues={onChangeValues}
            />
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
};
